/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    declare var localforage: any;

    export class ConfigurationStorageService {
        private logType = "ConfigurationStorageService";

        public constructor(private $q: angular.IQService) {

        }

        public storeProcessConfigInLocalStorage(id: string, processConfigByteArray: any): any {
            var cachedConfigurationIds = "";
            cachedConfigurationIds = this.updateCachedConfigIds(id);

            localforage.setItem(id, processConfigByteArray).catch(e => {
                if (this.isQuotaExceeded(e)) {
                    try {
                        WarsLogger.logError("Local Storage Exceeded - removing all cached configurations.",
                            this.logType);
                        this.clearConfigurationsFromLocalStorage(cachedConfigurationIds);
                        this.updateCachedConfigIds(id);
                        localforage.setItem(id, processConfigByteArray);
                    } catch (secondException) {
                        WarsLogger.logError(secondException, this.logType);
                    }
                }
            });

            return this.decompressAndDeserialize(processConfigByteArray);
        }

        private decompressAndDeserialize(byteArray: any): Wars.Domain.Model.ProcessConfiguration {
            var newLinesRemoved = byteArray.replace(/\s/g, '');
            var decompressed = this.deCompress(newLinesRemoved);
            return this.deserialize(decompressed);
        }

        private deCompress(byteArray: any): string {
            // Decode base64 (convert ascii to binary)
            var strData = atob(byteArray);
            // Convert binary string to character-number array
            var charData = strData.split("").map((x) => { return x.charCodeAt(0); });
            // Turn number array into byte-array
            var binData = new Uint8Array(charData);
            // Pako magic
            var data = pako.inflate(binData);
            // convert to unsigned 16 bit
            var arr = new Uint16Array(data);

            // Convert gunzipped byteArray back to ascii string:
            var json = [];
            ////process in reverse to remove the variable byte order markers at the front of the byte array
            for (var i = 0; i < arr.length; i++) {
                var char = String.fromCharCode(arr[i]);
                json.push(char);
            }

            return json.join("");
        }

        public getProcessConfigFromLocalStorage(id: string): angular.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            let d = this.$q.defer();

            var processConfiguration: Wars.Domain.Model.ProcessConfiguration = null;
            localforage.getItem(id).then((storedItem) => {
                if (storedItem) {
                    processConfiguration = this.decompressAndDeserialize(storedItem);
                    d.resolve(processConfiguration);
                } else {
                    d.resolve(null);
                }
            });

            return d.promise;
        }

        private updateCachedConfigIds(id: string): string {
            var cachedConfigurationIds = localStorage.getItem("cachedConfigurationIds");
            if (!cachedConfigurationIds) cachedConfigurationIds = "";
            if (cachedConfigurationIds.indexOf(id) === -1) {
                if (cachedConfigurationIds === "") {localStorage
                    cachedConfigurationIds = id;
                } else {
                    cachedConfigurationIds += "," + id;
                }
            }
            localforage.setItem("cachedConfigurationIds", cachedConfigurationIds);
            return cachedConfigurationIds;
        }

        private clearConfigurationsFromLocalStorage(cachedConfigurationIds: string) {
            var cachedConfigurationsToClear = cachedConfigurationIds.split(",");
            for (var i = 0; i < cachedConfigurationsToClear.length; i++) {
                localforage.removeItem(cachedConfigurationsToClear[i]);
            }
            localforage.setItem("cachedConfigurationIds", "");
        }

        private deserialize(jsonString: string): any {
            var jsonObject = JSON.parse(jsonString);
            return JsonNetDecycle.retrocycle(jsonObject);
        }

        private isQuotaExceeded(e: any): boolean {
            var quotaExceeded = false;
            if (e) {
                if (e.code) {
                    switch (e.code) {
                    case 22:
                        quotaExceeded = true;
                        break;
                    case 1014:
                        // Firefox
                        if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            quotaExceeded = true;
                        }
                        break;
                    }
                } else if (e.number === -2147024882) {
                    // Internet Explorer 8
                    quotaExceeded = true;
                }
            }
            return quotaExceeded;
        }
    }
}

warsApp.registerService('ConfigurationStorageService', ['$q']);